import { clone } from 'lodash';

class PropertyBrandFormController {
  constructor($scope, $state, propertiesService, messageService) {
    this.$scope = $scope;
    this.$state = $state;
    this.propertiesService = propertiesService;
    this.messageService = messageService;
  }

  $onInit(){
    this.messageService.clear();
    if (!this.property.brand){
      this.property.brand = {
        'primary' : '',
        'secondary' : '',
        'tertiary' : ''
      };
    }

    if (this.property.brand.header_font_type !== 'custom'){
      this.property.brand.header_font_path = this.property.brand.header_font_url || this.property.brand.header_font_path;
    }
    if (this.property.brand.body_font_type !== 'custom'){
        this.property.brand.body_font_path = this.property.brand.body_font_url || this.property.brand.body_font_path;
    }
  }

  onSave(){
    return this.propertiesService.saveBrand(this.property)
      .then(() => {
        this.messageService.success(`The brand for <strong>${this.property.name}</strong> was successfully updated!`);
        this.formTab = 'property';
        this.messageService.push();
        this.messageService.autoClear();
        
      })
      .catch((error) => {
        this.messageService.failure(`The brand for <strong>${this.property.name}</strong> could not be successfully updated: ${error.statusText}`);
        this.messageService.push();
      });
  }

  wipeFontFields(type){
    this.property.brand[type+'_font_family'] = undefined;
    this.property.brand[type+'_font_path'] = undefined;
    this.property.brand[type+'_font'] = undefined;
    this.property.brand[type+'_font_settings'] = undefined;
    this.property.brand[type+'_font_url'] = undefined;
  }
}

PropertyBrandFormController.$inject = [ '$scope', '$state', 'propertiesService', 'messageService' ];

export default PropertyBrandFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.brand.form.controller.js